import axios from 'axios'
import store from '@/store/store'

function buildMultipartHeaders() {
    const headers = {
        'apikey': process.env.VUE_APP_RTEK8DSR,
        'paraphrase': process.env.VUE_APP_BJ7DC3S
    }
    if (store.state && store.state.token) {
        headers['Authorization'] = 'Bearer ' + store.state.token
    }
    return headers
}

// Mapping ISO 3166-1 alpha-3 -> nom francais du pays (aligne sur pays.json)
const ISO_TO_PAYS = {
    SEN: 'Sénégal', FRA: 'France', CIV: "Côte d'Ivoire", MLI: 'Mali',
    GIN: 'Guinée', GNB: 'Guinée Bissau', GMB: 'Gambie', MRT: 'Mauritanie',
    MAR: 'Maroc', DZA: 'Algérie', TUN: 'Tunisie', EGY: 'Égypte',
    NGA: 'Nigéria', CMR: 'Cameroun', GHA: 'Ghana', TGO: 'Togo',
    BEN: 'Bénin', BFA: 'Burkina Faso', NER: 'Niger', TCD: 'Tchad',
    GAB: 'Gabon', COG: 'Congo', COD: 'République démocratique du Congo',
    CPV: 'Cap Vert', LBR: 'Libéria', SLE: 'Sierra Léone', CAF: 'Centrafrique',
    SOM: 'Somalie', MUS: 'Maurice',
    ESP: 'Espagne', PRT: 'Portugal', ITA: 'Italie', DEU: 'Allemagne',
    BEL: 'Belgique', NLD: 'Pays-Bas', CHE: 'Suisse', GBR: 'Royaume-Uni',
    GRC: 'Grèce', POL: 'Pologne', ROU: 'Roumanie', RUS: 'Russie',
    USA: 'États-Unis', CAN: 'Canada', BRA: 'Brésil', ARG: 'Argentine',
    MEX: 'Mexique', CHN: 'Chine', JPN: 'Japon', KOR: 'Corée du Sud',
    IND: 'Inde', PAK: 'Pakistan', THA: 'Thaïlande', VNM: 'Vietnam',
    LBN: 'Liban', TUR: 'Turquie', SAU: 'Arabie Saoudite', ARE: 'Émirats arabes unis',
    QAT: 'Qatar', JOR: 'Jordanie', SYR: 'Syrie', IRN: 'Iran', IRQ: 'Irak'
}

function deriveNationalite(codePays) {
    if (!codePays) return ''
    return ISO_TO_PAYS[String(codePays).toUpperCase()] || ''
}

function normalizeOcrResponse(response) {
    var payload = response && response.data
    var data = (payload && (payload.data || payload.result || payload.ocr || payload.passport)) || payload
    if (!data) return null

    var codePays = data.code_pays || data.countryCode || data.issuer || ''

    return {
        nom: data.nom || data.surname || data.lastName || '',
        prenom: data.prenom || data.givenName || data.firstName || '',
        numeroPasseport: data.numero_passeport || data.passportNumber || data.documentNumber || '',
        dateNaissance: data.date_naissance || data.birthDate || data.dateOfBirth || '',
        dateExpiration: data.date_expiration || data.expiryDate || data.dateOfExpiry || '',
        code_pays: codePays,
        nationalite: deriveNationalite(codePays),
        sexe: data.sexe || data.sex || data.gender || ''
    }
}

// Redimensionne et reencode l'image en JPEG en appliquant l'orientation EXIF.
// Corrige les cas typiques d'echec OCR sur capture live: photo > 5 Mo, orientation
// EXIF non appliquee (image vue "couchee" par le service tiers), HEIC iOS
// converti en JPEG par le navigateur mais avec meta cassees.
async function preprocessImage(file) {
    const MAX_DIMENSION = 1600
    const JPEG_QUALITY = 0.85

    let bitmap = null
    try {
        bitmap = await createImageBitmap(file, { imageOrientation: 'from-image' })
    } catch (e) {
        // Fallback pour navigateurs sans support imageOrientation (rare en 2026)
        bitmap = await createImageBitmap(file).catch(() => null)
    }
    if (!bitmap) throw new Error('IMAGE_DECODE_FAILED')

    const scale = Math.min(1, MAX_DIMENSION / Math.max(bitmap.width, bitmap.height))
    const width = Math.max(1, Math.round(bitmap.width * scale))
    const height = Math.max(1, Math.round(bitmap.height * scale))

    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const ctx = canvas.getContext('2d')
    ctx.drawImage(bitmap, 0, 0, width, height)
    if (bitmap.close) bitmap.close()

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY))
    if (!blob) throw new Error('IMAGE_ENCODE_FAILED')

    return new File([blob], 'passport.jpg', { type: 'image/jpeg', lastModified: Date.now() })
}

export default {
    preprocessImage,

    async scanPassport(file) {
        var formData = new FormData()
        formData.append('fichier', file)
        formData.append('file', file)

        var response = await axios.post(
            process.env.VUE_APP_API_URL + 'mypassports/ocr',
            formData,
            { headers: Object.assign({}, buildMultipartHeaders(), { 'Content-Type': 'multipart/form-data' }) }
        )

        var normalizedData = normalizeOcrResponse(response)
        if (!normalizedData || !normalizedData.dateNaissance) {
            throw new Error('OCR_INCOMPLETE_DATA')
        }
        return normalizedData
    },

    validateFile(file) {
        var allowedTypes = ['image/jpeg', 'image/png', 'image/jpg']
        var maxSize = 5 * 1024 * 1024 // 5MB

        if (!file) return { valid: false, error: 'NO_FILE' }
        if (!allowedTypes.includes(file.type)) return { valid: false, error: 'INVALID_TYPE' }
        if (file.size > maxSize) return { valid: false, error: 'FILE_TOO_LARGE' }
        return { valid: true }
    }
}
